import { gql } from "@apollo/client";
import { dmsFileInfo } from "features/insuranceDocument/queries/fragments";

export const DMS_FILES_INFO = gql`
  query dmsFilesInfo($fileId: ID) {
    dmsFilesInfo(fileId: $fileId) {
      ...dmsFileInfo
    }
  }
  ${dmsFileInfo}
`;
